import { Service } from "../shared/Service";

export class NaturezaService extends Service{

  constructor(){
    super('natureza');
  }

}